const tripStatus = require("./tripStatus");
const historyTripStatus = [
  tripStatus.finished,
  tripStatus.canceled,
  tripStatus.canceledBySystem,
  tripStatus.dispatcherCancelled,
];
module.exports = historyTripStatus;
